export const expressionHeaderText = "WAa";
export const userVoiceIdeasPaneHeader = "XAa";
export default {expressionHeaderText,userVoiceIdeasPaneHeader};